'use strict';

const CLASSES = {
    ACTIVE_BUTTON: 'fov-days-filter__button--active',
    ACTIVE_DAY: 'fov-schedule__day--active',
};

const SELECTORS = {
    BUTTONS: '.fov-days-filter__button',
    ACTIVE_BUTTONS: `.${CLASSES.ACTIVE_BUTTON}`,
    DAYS: '.fov-schedule__day',
    ACTIVE_DAYS: `.${CLASSES.ACTIVE_DAY}`,
};

function init() {
    [].forEach.call(document.querySelectorAll(SELECTORS.BUTTONS), el => {
        el.addEventListener('click', function() {
            // Clears the active selector for the buttons
            [].forEach.call(document.querySelectorAll(SELECTORS.ACTIVE_BUTTONS), el => {
                el.classList.remove(CLASSES.ACTIVE_BUTTON);
            });
            // Applies the active selector to this button
            el.classList.add(CLASSES.ACTIVE_BUTTON);

            // Clears the active selector for the buttons
            [].forEach.call(document.querySelectorAll(SELECTORS.ACTIVE_DAYS), el => {
                el.classList.remove(CLASSES.ACTIVE_DAY);
            });
            [].forEach.call(document.querySelectorAll(el.dataset.daySelector), el => {
                el.classList.add(CLASSES.ACTIVE_DAY);
            });
        }, false);
    })
}

module.exports = {
    init: init
};



// WEBPACK FOOTER //
// ./modules/fovScheduleDays.js